
export default  {
  bindings: {
    page: '='
  },
  controller: 'pageContentGenericController',
  template: require('../views/pageContent.email.html')
};
  


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/pageContent/components/pageContent.email.component.js